<template>
	<view class="success">
		<image src="/static/icon/ic_success@2x.png" mode="widthFix"></image>
		<view class="success-a">申请提现成功，等待系统处理</view>
		<view class="success-b">预计2小时内到账</view>
		<view class="success-info">
			<view class="success-info-item">
				<text>提现金额</text>
				<text>¥1000.00</text>
			</view>
			<view class="success-info-item">
				<text>提现方式</text>
				<text>微信领钱</text>
			</view>
		</view>
		<view class="success-btn" @click="goHome">回到首页</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		methods: {
			goHome() {
				uni.switchTab({
					url: '/pages/index/index'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.success {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		image {
			width: 180rpx;
			height: 180rpx;
			margin-top: 180rpx;
		}
		.success-a {
			font-weight: 500;
			font-size: 36rpx;
			color: #111111;
			margin-top: 40rpx;
		}
		.success-b {
			font-weight: 400;
			font-size: 26rpx;
			color: #999999;
			margin-top: 20rpx;
		}
		.success-info {
			width: 552rpx;
			padding: 30rpx;
			box-sizing: border-box;
			background: #F7F7F7;
			border-radius: 16rpx;
			margin-top: 60rpx;
			.success-info-item {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 30rpx;
				&:last-child {
					margin: 0 !important;
				}
				text {
					&:nth-child(1) {
						font-weight: 400;
						font-size: 28rpx;
						color: #999999;
					}
					&:nth-child(2) {
						font-weight: 400;
						font-size: 28rpx;
						color: #222222;
					}
				}
			}
		}
		.success-btn {
			width: 200rpx;
			height: 72rpx;
			line-height: 72rpx;
			text-align: center;
			font-weight: 400;
			font-size: 28rpx;
			color: #5BBE38;
			border-radius: 36rpx;
			margin-top: 80rpx;
			border: 1rpx solid #5BBE38;
		}
	}
</style>
